import axios from 'axios';
import AuthService from './AuthService';

const BASE = process.env.REACT_APP_API_URL;
const hdrs = () => ({ headers: { Authorization: `Bearer ${AuthService.getToken()}` } });
const unwrap = (d) => (Array.isArray(d) ? d : d?.$values ?? []);

const CrmWorkflowService = {
  getInterestsByLead: (leadId) =>
    axios.get(`${BASE}/LeadPropertyInterest/ByLead/${leadId}`, hdrs()).then((r) => unwrap(r.data)),

  upsertInterest: (dto) =>
    axios.post(`${BASE}/LeadPropertyInterest/Upsert`, dto, hdrs()).then((r) => r.data),

  deleteInterest: (id) =>
    axios.delete(`${BASE}/LeadPropertyInterest/Delete/${id}`, hdrs()).then((r) => r.data),

  getBuyerByLead: (leadId) =>
    axios.get(`${BASE}/Buyer/ByLead/${leadId}`, hdrs()).then((r) => r.data ?? null),

  getBuyerById: (id) =>
    axios.get(`${BASE}/Buyer/${id}`, hdrs()).then((r) => r.data ?? null),

  getBuyersByClient: (clientId) =>
    axios.get(`${BASE}/Buyer/ByClient/${clientId}`, hdrs()).then((r) => unwrap(r.data)),

  convertBuyerFromLead: (leadId) =>
    axios.post(`${BASE}/Buyer/ConvertFromLead/${leadId}`, {}, hdrs()).then((r) => r.data),

  updateBuyer: (dto) =>
    axios.put(`${BASE}/Buyer/Update`, dto, hdrs()).then((r) => r.data),

  getDealsByBuyer: (buyerId) =>
    axios.get(`${BASE}/Deal/ByBuyer/${buyerId}`, hdrs()).then((r) => unwrap(r.data)),

  getDealsByClient: (clientId) =>
    axios.get(`${BASE}/Deal/ByClient/${clientId}`, hdrs()).then((r) => unwrap(r.data)),

  createDeal: (dto) =>
    axios.post(`${BASE}/Deal/Create`, dto, hdrs()).then((r) => r.data),

  updateDeal: (dto) =>
    axios.put(`${BASE}/Deal/Update`, dto, hdrs()).then((r) => r.data),

  updateDealStage: (id, stage, lostReason = '') =>
    axios.put(`${BASE}/Deal/Stage/${id}`, null, { ...hdrs(), params: { stage, lostReason } }).then((r) => r.data),

  deleteDeal: (id) =>
    axios.delete(`${BASE}/Deal/Delete/${id}`, hdrs()).then((r) => r.data),
};

export default CrmWorkflowService;
